import SVG from './view';
export default SVG;
